import { render, staticRenderFns } from "./unknown-keyword.vue?vue&type=template&id=71b9e1ff&scoped=true&"
import script from "./unknown-keyword.vue?vue&type=script&lang=js&"
export * from "./unknown-keyword.vue?vue&type=script&lang=js&"
import style0 from "./unknown-keyword.vue?vue&type=style&index=0&id=71b9e1ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b9e1ff",
  null
  
)

export default component.exports